import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

export const StyledButton = styled(Button)`
  border-radius: 0;
  font-size: 20px;
  text-transform: none;
`;